import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CourseDistriBution from './AdminCharts/CourseDistriBution'
import PlatformUsage from './AdminCharts/PlatformUsage'
import TimeSpentChart from './AdminCharts/TimeSpentChart'
import Productivity from '../user/Productivity'
import CertifiedUsers from './CertifiedUsers'
import { BsArrowsAngleExpand } from "react-icons/bs";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const AdminDashboardCharts = ({ chartAnalytics, analytics, filter, group, loadingChart }) => {
    var navigate = useNavigate();
    const params = useParams();
    const { groupId } = params;
    var chartLabels = [];
    var activeUserValues = [];
    var inActiveUserValues = [];
    chartAnalytics?.users?.chart?.map((e, i) => {
        chartLabels.push(e.label);
        activeUserValues.push(e.counts.active);
        inActiveUserValues.push(e.counts.inactive);
    });
    const { modules } = analytics;
    modules.sort((a, b) => { return b.certificates - a.certificates });

    return (
        <>
            <div className="row admincharts mt-2">
                <div className=" col-lg-12 col-xl-9 col-xxl-9 ">
                    <div className="row">

                        <div className="col-md-6  ">
                            <div className="cardbox overflow-hidden custom-chart">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5> { loadingChart ? <Skeleton width="5vw"/> : <> Trainings </> }</h5>
                                    <p className="mb-1 d-flex align-items-flex">
                                    { loadingChart ? <Skeleton width="5vw"/> :
                                        <>
                                        Total : {chartAnalytics?.counts?.total?.all ?? 0}
                                        {chartAnalytics?.counts?.total?.all ?? 0 > 0 ?
                                          <span className='ms-3 enlargebtn' onClick={() => navigate(`/total-trainings-list/${groupId}`, { state: { filter: filter || null, group: group || null } })}><BsArrowsAngleExpand /></span>
                                          : null
                                        }
                                        </> }
                                        </p>
                                </div>
                                <div className='chartlegends'>
                                    <p>{ loadingChart ? <Skeleton width="5vw"/> : <> Guided : {chartAnalytics?.counts?.total?.guided ?? 0} </> }</p>
                                    <p>{ loadingChart ? <Skeleton width="5vw"/> : <> Unguided : {chartAnalytics?.counts?.total?.unguided ?? 0} </> }</p>
                                </div>
                                <PlatformUsage chartLabels={chartAnalytics?.counts?.chart ?? []} />
                            </div>
                        </div>
                        <div className="col-md-6 ">
                            <div className="cardbox overflow-hidden custom-chart">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5> { loadingChart ? <Skeleton width="5vw"/> : <>  Registered Users </> }</h5>
                                    <p className="mb-1">
                                    { loadingChart ? <Skeleton width="5vw"/> : <> Total : {chartAnalytics?.users?.total?.total ?? 0} </> }
                                    </p>
                                </div>
                                <div className='chartlegends'>
                                { loadingChart ? <Skeleton width="5vw"/> : <> <p>Active : {chartAnalytics?.users?.total?.active ?? 0} </p> </> }
                                { loadingChart ? <Skeleton width="5vw"/> : <> <p>Inactive : {chartAnalytics?.users?.total?.inactive ?? 0} </p> </> }
                                </div>
                                <Productivity page="adminDashboard" labels={chartLabels} guidedCounts={activeUserValues} unguidedCounts={inActiveUserValues} seriesName1="Active" seriesName2="Inactive" />
                            </div>
                        </div>

                        <div className="col-md-6 mt-3">

                            <div className="cardbox overflow-hidden custom-chart">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="mb-0"> { loadingChart ? <Skeleton width="5vw"/> : <>   Time Spent </> }</h5>
                                    <p className="mb-1">
                                    { loadingChart ? <Skeleton width="5vw"/> : <>    Total Time : {chartAnalytics?.duration?.total?.all?.sum?.humanReadable ?? 0} </> }
                                    </p>
                                </div>
                                <div className='chartlegends'>
                                    <p> { loadingChart ? <Skeleton width="5vw"/> : <>  Guided : {chartAnalytics?.duration?.total?.guided?.sum?.humanReadable ?? 0} </> } </p>
                                    <p> { loadingChart ? <Skeleton width="5vw"/> : <> Unguided : {chartAnalytics?.duration?.total?.unguided?.sum?.humanReadable ?? 0} </> } </p>
                                </div>
                                <TimeSpentChart chartLabels={chartAnalytics?.duration?.chart ?? []} loadingChart={loadingChart} />
                            </div>
                        </div>


                        <div className="col-md-6 mt-3">
                            <div className="cardbox overflow-hidden custom-chart">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="mb-1">{ loadingChart ? <Skeleton width="5vw"/> : <>  Language Preferred </> }</h5>
                                </div>
                                <CourseDistriBution language={analytics?.languageCounts || []} loadingChart={loadingChart} />
                            </div>
                        </div>

                    </div>
                </div>
                <div className=" col-lg-12 col-xl-3 col-xxl-3 ">

                    <div className="cardbox position-relative h-100">
                        <CertifiedUsers certifiedUsersCount={modules} loadingChart={loadingChart}/>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdminDashboardCharts
